import { render, staticRenderFns } from "./DeliveryStepReturnToHq.vue?vue&type=template&id=41a6d5b7&"
import script from "./DeliveryStepReturnToHq.vue?vue&type=script&lang=js&"
export * from "./DeliveryStepReturnToHq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports